import { render, staticRenderFns } from "./SavingWrapper.vue?vue&type=template&id=253cb724&scoped=true&"
import script from "./SavingWrapper.vue?vue&type=script&lang=js&"
export * from "./SavingWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SavingWrapper.vue?vue&type=style&index=0&id=253cb724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253cb724",
  null
  
)

export default component.exports